import WasmController from "react-lib/frameworks/WasmController";
import { State as MainState } from "react-lib/apps/segment/SegmentInterface";

// APIs
import MeHealthPackageListView from "issara-sdk/apis/MeHealthPackageListView_apps_MEH";

import * as PRXI from "HIS/Interface/PRXI";
import CONFIG from "config/config";
import OfficialAccountDivisionDetail from "issara-sdk/apis/OfficialAccountDivisionDetail_apps_PRXM";
import MeHealthPackageAddToCartView from "issara-sdk/apis/MeHealthPackageAddToCartView_apps_MEH";
import MeHealthInvoiceItemListView from "issara-sdk/apis/MeHealthInvoiceItemListView_apps_MEH";
import MeHealthInvoiceItemDetailView from "issara-sdk/apis/MeHealthInvoiceItemDetailView_apps_MEH";
import MeHealthPaymentMethodListView from "issara-sdk/apis/MeHealthPaymentMethodListView_apps_MEH";
import MeHealthInvoiceCreateView from "issara-sdk/apis/MeHealthInvoiceCreateView_apps_MEH";
import PaymentStatusChecker from "./PaymentStatusChecker";
import MeHealthReceiptCreateView from "issara-sdk/apis/MeHealthReceiptCreateView_apps_MEH";
import MeHealthInvoiceDetailView from "issara-sdk/apis/MeHealthInvoiceDetailView_apps_MEH";
import MeHealthCreditWalletLatestDetailView from "issara-sdk/apis/MeHealthCreditWalletLatestDetailView_apps_MEH";
import MeHealthCreditWalletTransactionListView from "issara-sdk/apis/MeHealthCreditWalletTransactionListView_apps_MEH";
import FormPackageReceipt from "../pdfForm/FormPackageReceipt";
import getPdfMake from "react-lib/appcon/common/pdfMake";
import moment from "moment";
import { ADMIN_NAME_LIST } from "react-lib/apps/USER/CardSettingDivision";

import jwt_encode from "jwt-encode";
import {jwtDecode} from "jwt-decode";

export const PROMPT_PAY_TYPE = "PROMTPAY";
export const CARD_TYPE = "CARD";

export type State = {
  BillingCreditWallet: any;
  BillingCarts: any;
  BillingAndPackageSequence: {
    sequenceIndex?: string | null;
    divisionProfile: any;
    meHealthPackageList: any;
    addToCardLoading: boolean;
    openTransactionModal: boolean;
    openPaidPackageModal: boolean;
    openPaidResultModal: boolean;
    open2C2PPaymentModal: boolean;
    transactions: {
      formData: {
        email: string;
        address: string;
        taxId: string;
      };
      paidResult: any
    };
    paymentMethods: any;
    paymentCheckerPolling: any;
    paymentHistory: any;
    paymentHistoryLoading: boolean;
    creditUsageList: any;
    creditUsageLoading: boolean;
  } | null;
};

export const StateInitial: State = {
  BillingCreditWallet: null,
  BillingCarts: null,
  BillingAndPackageSequence: {
    sequenceIndex: null,
    divisionProfile: {},
    meHealthPackageList: {},
    addToCardLoading: false,
    openTransactionModal: false,
    openPaidPackageModal: false,
    open2C2PPaymentModal: false,
    transactions: {
      formData: {
        email: "",
        address: "",
        taxId: "",
      },
      paidResult: null,
    },
    paymentMethods: null,
    paymentCheckerPolling: null,
    paymentHistory: null,
    paymentHistoryLoading: false,
    creditUsageList: null,
    creditUsageLoading: false,
  },
};

export type Props = {};

export type Event =
  | { message: "RunSequence"; params: {} }
  | { message: "GetMasterData"; params: {} };

export type Data = {
  division?: number;
};

type Picked = Partial<
  Pick<MainState, "handleEvent" | "errorMessage" | "successMessage" | "masterOptions">
>;

export const DataInitial = {};

type Handler<P = any, R = any> = (
  controller: WasmController<State & Picked, Event, Data, Props>,
  params: P
) => R;

export const Start: Handler = async (controller, params) => {
  let divisionProfile = {};
  let meHealthPackageList = {};
  let carts = {};
  try {

    divisionProfile = await GetDivisionProfile(controller,params);

    const [list] = await MeHealthPackageListView.list({
      params: {
        active_flag: "ACTIVE"
      },
      extra: { division: controller.data.division || 0 },
      apiToken: controller.apiToken,
    });

    const cart = await GetCartList(controller, params);
    console.log("cart: ", cart);

    // console.log("res: ", res);
    console.log("list: ", list);

    if (list) {
      meHealthPackageList = list;
      console.log("meHealthPackageList: ", meHealthPackageList);
    }

    if (cart) {
      carts = cart;
    }
  } catch (error) {
    console.error("Error fetching division profile:", error);
  }

  controller.setState({
    BillingCarts: carts,
    BillingAndPackageSequence: {
      sequenceIndex: "Action",
      divisionProfile,
      meHealthPackageList,
    },
  });
};

export const Action: Handler = async (controller, params) => {
  switch (params.action) {
    case "ADD_TO_CART":
      return AddToCard(controller, params);
    case "PAID":
      return PaidPackage(controller, params);
    case "CREATE_INVOICE":
      return CreateInvoice(controller, params);
    case "BACK_TRANSACTION_SUMMARY":
      return BackToTransactionSummary(controller, params);
    case "GET_PAID_CHOICE":
      return GetPaidChoice(controller, params);
    case "PROMPTPAY_SELECTED":
      return PropmtPaySelected(controller, params);
    case "CARD_SELECTED":
      return CardSelected(controller, params);
    case "START_PERIODIC_PAYMENT_CHECK":
      return PeriodicCheck(controller, params);
    case "GO_TO_BILLING_PACKAGE":
      return GoToBillingPackage(controller, params);
    case "DOWNLOAD_RECEIPT":
      return HandlePackageReceiptFile(controller, params);
    case "GET_RECEIPT_LIST":
      return GetReceiptList(controller, params);
    case "GET_CREDIT_USAGE_LIST":
      return GetCreditUsageList(controller, params);
    case "GET_CREDIT_WALLET":
      return GetCreditWallet(controller, params);
    // case "GET_ACTIVE_PACKAGE_LIST":
    //   return GetActivePackageList(controller, params);
    case "EDIT_QTY_CARTS":
      return EditQuantityCarts(controller, params);
    case "REMOVE_PACKAGE_CARTS":
      return RemovePackageCarts(controller, params);
    case "2C2P_SUCCESS":
      return SuccessPaid2C2P(controller, params);
    default:
      break;
  }
};

const SuccessPaid2C2P: Handler = async (controller, params) => {

  controller.setState((prevState) => {
    return {
      BillingAndPackageSequence: {
        ...prevState.BillingAndPackageSequence,
        open2C2PPaymentModal: false,
      },
    };
  });
};


const GetDivisionProfile: Handler = async (controller, params) => { 
    const [res] =  await OfficialAccountDivisionDetail.retrieve({
      params: {},
      extra: { division: controller.data.division || 0 },
      apiToken: controller.apiToken,
    });

    let divisionProfile = {}
    if (res) {
      divisionProfile = {
        ...res,
        account_link: res.token
          ? `${CONFIG.OFFICIAL_ACCOUNT_HOST || "https://ishealth.app"}/OA/${
              res.id
            }/?openExternalBrowser=1`
          : "",
        division_address: {
          city: res.city?.id,
          district: res.district?.id,
          province: res.province?.id,
          full_address_text: res.address_text,
          zipcode: res.city?.zipcode,
          place_id: res.place_id,
          latitude: res.latitude,
          longitude: res.longitude,
        },
        division_name: res.division_name,
        hospital_name: res.hospital_name,
        image_file: res.image_file,
        address_text: res.address_text,
        tax_id: res?.tax_id,
      };
    }

    return divisionProfile

}
const RemovePackageCarts: Handler = async (controller, params) => {
  let { BillingCarts } = controller.getState();
  let item = (BillingCarts?.items || []).find((i: any) => i.id === params.id);
  if (item) {
    let [res, err, network] = await MeHealthInvoiceItemDetailView.delete({
      pk: params.id,
      apiToken: controller.apiToken,
      extra: { division: controller.data.division || 0 },
    });

    if (err) {
      console.warn("cannot set qty");
    }
    if (network.status === 204) { 
      const inCart = await GetCartList(controller, params);
      controller.setState({ BillingCarts: inCart });
    }

  }
};

const EditQuantityCarts: Handler = async (controller, params) => {
  let { BillingCarts } = controller.getState();
  let item = (BillingCarts?.items || []).find((i: any) => i.id === params.id);
  if (item) {
    let qty = Math.max(0, Number(item.quantity) + params.delta);

    let [res, err] = await MeHealthInvoiceItemDetailView.update({
      pk: params.id,
      data: { quantity: qty },
      apiToken: controller.apiToken,
      extra: { division: controller.data.division || 0 },
    });

    if (err) {
      console.warn("cannot set qty");
    }
    if (res) {
      const inCart = await GetCartList(controller, params);
      controller.setState({ BillingCarts: inCart });
    }
  }
};



const GetCreditWallet: Handler = async (controller, params) => {
  let [res, err] = await MeHealthCreditWalletLatestDetailView.retrieve({
    apiToken: controller.apiToken,
    extra: { division: controller.data.division || 0 },
  });

  if (err) {
    console.warn("GetCreditWallet err: ", err);
    return;
  }

  console.log("GetCreditWallet res: ", res);
  if (res) {
    controller.setState((prevState) => {
      return {
        BillingCreditWallet: res,
        // BillingAndPackageSequence: {
        //   ...prevState.BillingAndPackageSequence,
        //   creditWallet: res
        // },
      };
    });
  }
};

const GetCreditUsageList: Handler = async (controller, params) => {
  controller.setState((prevState) => {
    return {
      BillingAndPackageSequence: {
        ...prevState.BillingAndPackageSequence,
        creditUsageLoading: true,
      },
    };
  });

  // const meHealthPackageList =
  //   controller.getState()?.BillingAndPackageSequence?.meHealthPackageList?.items || [];

  const [res, err] = await MeHealthCreditWalletTransactionListView.list({
    apiToken: controller.apiToken,
    extra: { division: controller.data.division || 0 },
    params: {
      order_no: params?.credit_no || null,
      credit_use: params?.credit_use || null,
      start_date: params?.credit_date_start || null,
      end_date: params?.credit_date_end || null,
    },
  });

  if (err) {
    console.warn("Error fetching receipts:", err);

    controller.setState((prevState) => {
      return {
        BillingAndPackageSequence: {
          ...prevState.BillingAndPackageSequence,
          creditUsageLoading: false,
          creditUsageList: null,
        },
      };
    });

    return null;
  }

  controller.setState((prevState) => {
    return {
      BillingAndPackageSequence: {
        ...prevState.BillingAndPackageSequence,
        creditUsageLoading: false,
        creditUsageList: res || null,
      },
    };
  });

  console.log("GetReceiptList res: ", res);
  return res || null;
};

const GoToBillingPackage: Handler = async (controller, params) => {

    // ถ้าอยู่หน้า Billing & Package อยู่แล้ว แค่ ปิด Modal 
  // แต่ถ้า อยู่หน้าอื่น ให้มา Billing & Package
  const state = controller.getState()
  if (state.showTabName !== ADMIN_NAME_LIST["Billing & Package"]) {

    console.log('params.tabAdminRef: ', params.tabAdminRef);
    params.tabAdminRef?.changeTabKey(ADMIN_NAME_LIST["Billing & Package"]);
  } else { 
    controller.setState({
      BillingAndPackageSequence: {
        ...state.BillingAndPackageSequence,
        openPaidResultModal: false
      },
    });
  }
};

const PeriodicCheck: Handler = async (controller, params) => {
  let state = controller.getState();

  if (state.BillingAndPackageSequence?.paymentCheckerPolling?.stop) {
    state.BillingAndPackageSequence?.paymentCheckerPolling.stop();
  }

  if (!state.BillingAndPackageSequence?.paymentCheckerPolling) {
    let apiToken = controller.apiToken;
    let division = `${controller.data.division || 0}`;

    const success = async (data: any) => {
      console.log('data: ', data);

      const carts = await GetCartList(controller, params);

      let [res, err] = await MeHealthCreditWalletLatestDetailView.retrieve({
        apiToken: controller.apiToken,
        extra: { division: controller.data.division || 0 },
      });


      controller.setState((prevState: any) => {
        return {
          ...(carts && {BillingCarts: carts}),
          ...(res &&{ BillingCreditWallet: res }),
          BillingAndPackageSequence: {
            ...prevState.BillingAndPackageSequence,
            paymentCheckerPolling: null,
            openPaidPackageModal: false,
            openPaidResultModal: true,
            transactions: {
              ...prevState.BillingAndPackageSequence.transactions,
              prepareInvoice: {},
              paidResult: data,
            },
          },
        };
      });
    };

    const failed = (data?: any) => {
      controller.setState((prevState: any) => {
        return {
          BillingAndPackageSequence: {
            ...prevState.BillingAndPackageSequence,
            transactions: {
              ...prevState.BillingAndPackageSequence.transactions,
              prepareInvoice: {},
              ...(data && { paidResult: data }),
            },
            paymentCheckerPolling: null,
            openPaidPackageModal: false,
            openPaidResultModal: true,
          },
        };
      });
    };

    let checker = null
    if (params.invoiceId) {

      checker = new PaymentStatusChecker(params.invoiceId, apiToken, division, {
        initialInterval: 5000, // Start checking every 2 seconds
        maxInterval: 30000, // Max 30 seconds between checks
        // maxAttempts: 50, // Stop after 50 attempts
        // timeout: 5 * 60 * 1000, // Stop after 5 minutes
  
        onComplete: (data) => {
          console.log("Payment completed:", data);
          // Redirect or show success message
          // window.location.href = "/payment/success";
          success(data);
        },
  
        onFailed: (data) => {
          console.log("Payment failed:", data);
          failed();
        },
  
        onPending: (data, attempts) => {
          if (attempts === 1) {
            controller.setState((prevState: any) => {
              return {
                BillingAndPackageSequence: {
                  ...prevState.BillingAndPackageSequence,
                  transactions: {
                    ...prevState.BillingAndPackageSequence.transactions,
                    paidResult: data,
                  },
                },
              };
            });
          }
          console.log(`Payment pending... data: `, data, ` (attempt ${attempts})`);
        },
  
        // onTimeout: () => {
        //   console.log("Payment check timed out");
        //   failed();
        // },
  
        onError: (error, attempts) => {
          console.error(`Error on attempt ${attempts}:`, error);
          failed();
        },
  
        // onMaxAttempts: () => {
        //   console.error(`Error on onMaxAttempts `);
        //   failed();
        // },
      });
  
      checker.start();
    }

    if (checker )  {
      controller.setState((prevState: any) => {
        return {
          BillingAndPackageSequence: {
            ...prevState.BillingAndPackageSequence,
            paymentCheckerPolling: checker,
          },
        };
      });
    }
  }
};

const GetPaidChoice: Handler = async (controller, params) => {
  let [res, err] = await MeHealthPaymentMethodListView.get({
    apiToken: controller.apiToken,
    extra: { division: controller.data.division || 0 },
  });

  if (err) {
    console.warn("GetPaidChoice error: ", err);
    controller.setState((prevState: any) => {
      return {
        BillingAndPackageSequence: {
          ...prevState.BillingAndPackageSequence,
          paymentMethods: { items: [], total: 0, next: null, previous: null },
        },
      };
    });
  }

  if (res) {
    console.log("res: ", res);
    controller.setState((prevState: any) => {
      let addQrCodeInItems: any[] = res.items;
      let idx = addQrCodeInItems.findIndex((i: any) => i.type === PROMPT_PAY_TYPE);
      console.log("idx: ", idx);
      // TODO: Debug
      if (idx != -1) {
        addQrCodeInItems[idx].qr_image_base64 =
          "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";
      }

      return {
        BillingAndPackageSequence: {
          ...prevState.BillingAndPackageSequence,
          paymentMethods: { items: addQrCodeInItems },
          // paymentMethods: res
        },
      };
    });
  }
};

const PropmtPaySelected: Handler = async (controller, params) => {};

const CardSelected: Handler = async (controller, params) => {

  let state = controller.getState()

  const generateToken = async () => {
  // !!! NEVER put real secret keys in frontend!
  // TODO://  NEVER put real secret keys in frontend!
  const secret = '6967C96CEBFAC8E162ABA87B5555650143732ECF472C6CCCCB74A1A9872285DD';
  

  const payload = {
    merchantID: "764764000003870",
    invoiceNo: state.BillingAndPackageSequence?.transactions?.prepareInvoice?.id,
    description: `Total ${state.BillingAndPackageSequence?.transactions?.prepareInvoice?.items?.length}` ,
    amount: state.BillingAndPackageSequence?.transactions?.prepareInvoice?.total_price_included_vat.replace(/,/g, ""),
    currencyCode: "THB",
    tokenize: true,
    // customerToken: ["24112509345967463942"],
    // customerTokenOnly: true,
    // iframeMode: true,
    paymentChannel: ["CC"],
    // frontendReturnUrl: `${window.location.origin}/?app=HIS`,
    // frontendReturnUrl: "https://mehealth-api.ishealth.app/apis/MEH/me-health-receipt",
    backendReturnUrl: "https://paymentpost-zrggczf6jq-de.a.run.app",

  };
  console.log('payload: ', payload);
  
  const jwt = jwt_encode(payload, secret);
  console.log('payload jwt: ', jwt);

  const response = await fetch('https://sandbox-pgw.2c2p.com/payment/4.3/paymentToken', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({payload: jwt}) 
  })

  
  const data = await response.json();
  console.log('data: ', data);
  const decoded = jwtDecode(data?.payload);
  console.log('decoded: ', decoded);

  
  controller.setState((prevState) => { 
    return { 
      BillingAndPackageSequence: {
        ...prevState.BillingAndPackageSequence,
        open2C2PPaymentModal: true,
        webPaymentUrl: decoded?.webPaymentUrl
      }
    }

  })
};

generateToken()



};

const PaidPackage: Handler = async (controller, params) => {
  // if (res) {
  controller.setState((prevState: any) => {
    return {
      BillingAndPackageSequence: {
        ...prevState.BillingAndPackageSequence,
        openTransactionModal: false,
        openPaidPackageModal: true,
        // transactions: {
        //   ...prevState.BillingAndPackageSequence?.transactions,
        //   prepareInvoice: res
        // }
      },
    };
  });
};
// }

const CreateInvoice: Handler = async (controller, params) => {
  let state = controller.getState();
  let items = state.BillingCarts?.items
    ?.filter((i: any) => {
      let qty = 0;
      if (typeof i.quantity === "string") {
        qty = Number(i.quantity.replace(/,/g, ""));
      } else if (typeof i.quantity === "number") {
        qty = i.quantity;
      }

      if (qty > 0) {
        return true;
      } else {
        return false;
      }
    })
    ?.map((i: any) => ({
      id: i.id,
      quantity: Number(i.quantity),
    }));

  // let divisionProfile: any = {}
  // if (state.BillingAndPackageSequence?.divisionProfile) {
  //   divisionProfile = state.BillingAndPackageSequence?.divisionProfile
  // } else {
  //   divisionProfile = await GetDivisionProfile(controller,params);
  // }

  // const fullAddress = (() => {
  //   const profile = divisionProfile;
  //   if (!profile) return "";

  //   const { business_type, branch_type, branch_name, business_name, first_name, last_name, address_text } = profile;

  //   let suffix = branch_type === "HEADQUARTER"
  //     ? "สำนักงานใหญ่"
  //     : branch_type === "BRANCH" && branch_name
  //       ? branch_name
  //       : "";

  //   let line1 = business_type === "INDIVIDUAL"
  //     ? `${first_name || ""} ${last_name || ""}`.trim()
  //     : business_name || "";

  //   if (suffix) line1 = `${line1} ${suffix}`;

  //   return `${line1}\n${address_text || ""}`.trim();
  // })();

  
  console.log('state.BillingAndPackageSequence?.transactions:  ', state.BillingAndPackageSequence?.transactions);

  let [res, err] = await MeHealthInvoiceCreateView.post({
    apiToken: controller.apiToken,
    extra: { division: controller.data.division || 0 },
    data: {
      email: state.BillingAndPackageSequence?.transactions?.formData.email,
      tax_invoice_address: state.BillingAndPackageSequence?.transactions?.formData.address ,
      taxpayer_id: state.BillingAndPackageSequence?.transactions?.formData.taxId ,
      items,
    },
  });

  if (err) {
    console.warn("Cannot create invoice", err);
    return;
  }

  if (res) {
    controller.setState((prevState: any) => {
      return {
        BillingAndPackageSequence: {
          ...prevState.BillingAndPackageSequence,
          openTransactionModal: false,
          openPaidPackageModal: true,
          transactions: {
            ...prevState.BillingAndPackageSequence?.transactions,
            prepareInvoice: res,
          },
        },
      };
    });
  }
};

const BackToTransactionSummary: Handler = async (controller, params) => {
  controller.setState((prevState: any) => {
    return {
      BillingAndPackageSequence: {
        ...prevState.BillingAndPackageSequence,
        openTransactionModal: true,
        openPaidPackageModal: false,
      },
    };
  });
};

const AddToCard: Handler = async (controller, params) => {
  controller.setState((prevState: any) => {
    return {
      BillingAndPackageSequence: {
        ...prevState.BillingAndPackageSequence,
        addToCartLoading: true,
      },
    };
  });

  let data = {
    items: [
      {
        id: params.id,
        quantity: params.quantity,
      },
    ],
  };

  const [res, err] = await MeHealthPackageAddToCartView.post({
    data,
    apiToken: controller.apiToken,
    extra: { division: controller.data.division || 0 },
  });

  if (err) {
    console.warn(err);
  }

  let inCart = {};
  if (res) {
    // Add Success
    inCart = await GetCartList(controller, params);
  }

  // console.log("res: ", res);

  controller.setState((prevState: any) => {
    return {
      BillingCarts: inCart,
      BillingAndPackageSequence: {
        ...prevState.BillingAndPackageSequence,
        addToCartLoading: false,
      },
    };
  });
};

const GetCartList: Handler = async (controller, params) => {
  const [res, err] = await MeHealthInvoiceItemListView.list({
    apiToken: controller.apiToken,
    params: {has_invoice : false, status: "BILLED"},
    extra: { division: controller.data.division || 0 },
  });

  if (err) {
    console.warn(err);
  }
  let cartItems = null;
  if (res) {
    cartItems = res;
  }

  return cartItems;
};

// const UpdateCartItem: Handler = async (controller, params) => {
//   const cartItems = await GetCartItems(controller, params);

//   console.log("cartItems: ", cartItems);

//   controller.setState((prevState: any) => {
//     return {
//       BillingAndPackageSequence: {
//         ...prevState.BillingAndPackageSequence,
//         getCartItemsLoading: false,
//         cartItems,
//       },
//     };
//   });
// };

export const GetReceiptList: Handler = async (controller, params) => {
  controller.setState((prevState) => {
    return {
      BillingAndPackageSequence: {
        ...prevState.BillingAndPackageSequence,
        paymentHistoryLoading: true,
      },
    };
  });

  let payoutDateStart = params?.payout_date_start;
  let payoutDateEnd = params?.payout_date_end;

  if (!payoutDateStart || !payoutDateEnd) {
    const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
    const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");

    payoutDateStart = payoutDateStart || startOfMonth;
    payoutDateEnd = payoutDateEnd || endOfMonth;
  }

  const meHealthPackageList =
    controller.getState()?.BillingAndPackageSequence?.meHealthPackageList?.items || [];

  let packageId: number | null = null;
  if (params?.package) {
    const matchedPackage = meHealthPackageList.find((pkg: any) => pkg.name === params.package);
    packageId = matchedPackage ? matchedPackage.id : null;
  }
  const queryParams = {
    order_no: params?.order_no || null,
    package: packageId || null,
    payout_date_start: payoutDateStart,
    payout_date_end: payoutDateEnd,
  };

  const extraParams = {
    division: controller.data.division || 0,
  };

  const [res, err] = await MeHealthReceiptCreateView.list({
    apiToken: controller.apiToken,
    params: queryParams,
    extra: extraParams,
  });

  if (err) {
    console.warn("Error fetching receipts:", err);
    return null;
  }

  controller.setState((prevState) => {
    return {
      BillingAndPackageSequence: {
        ...prevState.BillingAndPackageSequence,
        paymentHistoryLoading: false,
        paymentHistory: res || null,
      },
    };
  });

  console.log("GetReceiptList res: ", res);
  return res || null;
};



export const GetInvoiceDetail: Handler = async (controller, params) => {
  if (!params?.pk) {
    console.warn("Invoice ID (pk) is required.");
    return null;
  }

  const [res, err] = await MeHealthInvoiceDetailView.retrieve({
    pk: params.pk,
    apiToken: controller.apiToken,
    extra: { division: controller.data.division || 0 },
  });

  if (err) {
    console.warn("Error fetching invoice detail:", err);
    return null;
  }

  return res || null;
};

export const HandlePackageReceiptFile: Handler = async (controller, params) => {
  const receipt = params.receipt;
  if (!receipt) {
    console.warn("No receipt provided.");
    return;
  }

  const invoiceId = receipt.invoice;

  const invoice = await GetInvoiceDetail(controller, { pk: invoiceId });
  if (!invoice) {
    console.warn("Invoice not found for ID:", invoiceId);
    return;
  }

  const items = (invoice.items || []).map((inv: any, index: number) => {
    const pkg = inv.package;
    const priceNum = Number(pkg?.price?.replace(/,/g, "") || 0);
    const creditNum = Number(pkg?.credit_amount?.replace(/,/g, "") || 0);
    const qty = Number(inv.quantity || 1);

    return {
      no: index + 1,
      description: `${
        pkg?.name || "Package"
      } (${priceNum.toLocaleString()} บาท ได้รับ ${creditNum.toLocaleString()} Credit)`,
      qty,
      unit_price: priceNum,
      price: Number(inv.price?.replace(/,/g, "") || 0),
    };
  });

  const receiptNo = receipt.code || `RCPT-${Date.now()}`;

  const formatDateLong = (iso?: string) => {
    if (!iso) return "-";
    const d = new Date(iso);
    return d.toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" });
  };
  const receiptDate = formatDateLong(receipt.created_at);

  const splitAddressByWords = (address: string, maxLength = 40) => {
    const words = address.split(/\s+/);
    const lines: string[] = [];
    let currentLine = "";

    for (const word of words) {
      if ((currentLine + " " + word).trim().length > maxLength) {
        lines.push(currentLine.trim());
        currentLine = word;
      } else {
        currentLine += " " + word;
      }
    }
    if (currentLine.trim()) lines.push(currentLine.trim());
    return lines;
  };

  const formatThaiTaxId = (taxId: string) => {
    if (!taxId) return "x xxxx xxxxx xx x";
    const digits = taxId.replace(/\D/g, "");
    if (digits.length !== 13) return taxId;
    return `${digits[0]} ${digits.slice(1, 5)} ${digits.slice(5, 10)} ${digits.slice(
      10,
      12
    )} ${digits.slice(12)}`;
  };

  const pdfMake = await getPdfMake(true);

  const docDefinition = await FormPackageReceipt({
    receipt_no: receiptNo,
    date: receiptDate,
    buyer_tax_id: formatThaiTaxId(invoice.taxpayer_id || params.taxpayer_id || ""),
    buyer_address_lines: splitAddressByWords(
      invoice.tax_invoice_address || params.tax_invoice_address || "",
      40
    ),
    items,
    total_price_num: invoice.total_price,
    vat: invoice.total_price_vat,
    total_incl_vat: invoice.total_price_included_vat,
    total_price_text: invoice.total_price_text,
  });

  pdfMake.createPdf(docDefinition).download(`Receipt_${receiptNo}`);
};

